import { AxiosResponse, AxiosError } from 'axios'
import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

interface CreateMedicalReferralProps {
  medicalReferral: string
  planCode: string
  medicalReferralIdentifier: string
}

const createMedicalReferral = ({
  medicalReferral,
  planCode,
  medicalReferralIdentifier
}: CreateMedicalReferralProps): Promise<AxiosResponse | AxiosError> => {
  return new Promise((resolve, reject) => {
    const endpoint = apiEndpoints.PATIENTS_MEDICAL_REFERRAL

    const payload = {
      medical_referral: medicalReferral,
      plan_code: planCode,
      medical_referral_identifier: medicalReferralIdentifier,
    }

    axios.post(endpoint, payload)
      .then(res => resolve(res))
      .catch(err => reject(err))
  })
}

export {
  createMedicalReferral
}

